import { getSourcesByUnknownAge } from 'utils/clickme';

import { setCampaignSubSource, setCampaignUnknownAge } from 'store/models/createCampaign';
import { AppThunkAction } from 'store/utils';

export const setUnknownAgeWithSources = (adUnknownAge: boolean): AppThunkAction<void> => {
    return (dispatch, getState) => {
        const { adSource } = getState().createCampaign;
        const newSources = getSourcesByUnknownAge(adSource, !adUnknownAge);
        dispatch([setCampaignUnknownAge(!adUnknownAge), setCampaignSubSource(newSources)]);
    };
};
